import { render, staticRenderFns } from "./About_page.vue?vue&type=template&id=7f54da54&"
import script from "./About_page.vue?vue&type=script&lang=js&"
export * from "./About_page.vue?vue&type=script&lang=js&"
import style0 from "./About_page.vue?vue&type=style&index=0&id=7f54da54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports